<template>
  <div @click="toNav">跳转</div>
</template>
<script>
export default {
  methods: {
    toNav() {
      console.log(window, 'window')
      // window.open('http://www.baidu.com','_self')
      // window.location.replace('http://www.baidu.com')
      // console.log(window.location)
      // this.$router.replace('test1')
      this.$router.push('test1')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/page/test.vue